import { puzzlesJson } from "../json/puzzles.json";
import { wordsJson } from "../json/words.json";

var lib = function() 
{
    function getTopWords(gameJson)
    {    
        var topWords = [];

        var lastWordPoints = 0;

        for (var i = 0; i < gameJson["a"].length; i++)
        {
            var word = getWordFromId(gameJson["a"][i]);
            var points = getWordPoints(word);

            if (topWords.length >= 5 && points < lastWordPoints) {
                break;
            }
            
            lastWordPoints = points;

            topWords.push(word);
        }

        return topWords;
    }
    
    function getWordFromId(wordId)
    {
        var word = "";

        if (wordsJson !== undefined)
        {
            [].forEach.call(wordsJson, function(w) {
                if (w["i"] === wordId) 
                {
                    word = w["w"];
                }
            });
        }

        return word;
    }

    function getWordPoints(word)
    {
        var points = 0;

        for (var i = 0; i < word.length; i++)   
        {
            if (!(i - 1 >= 0 && word[i - 1].toLowerCase() === "q")) // skip 'u' if it is preceded by 'q'
            {
                var letter = word[i].toLowerCase();
                
                var letterPoints = getLetterPoints(letter);
                
                points += letterPoints;
            }
        }

        return points;
    }

    function getLetterPoints(letter)
    {
        var letterPoints = 0;

        switch (letter.toLowerCase()) {
            case "a":
            case "e":
            case "i":
            case "o":
            case "u":
            case "l":
            case "n":
            case "s":
            case "t":
            case "r":
                letterPoints = 1;
                break;
            case "d":
            case "g":
                letterPoints = 2;
                break;
            case "b":
            case "c":
            case "m":
            case "p":
                letterPoints = 3;
                break;
            case "f":
            case "h":
            case "v":
            case "w":
            case "y":
                letterPoints = 4;
                break;
            case "k":
                letterPoints = 5;
                break;
            case "j":
            case "x":
                letterPoints = 6;
                break;
            case "q":
            case "z":
                letterPoints = 7;
                break;
        }

        return letterPoints;
    }

    function getPercentageScoreClass(percentageScore)
    {
        if (percentageScore < 50) 
        {
            return "p1";
        }
        else if (percentageScore >= 50 && percentageScore < 60)
        {
            return "p2";
        }
        else if (percentageScore >= 60 && percentageScore < 70)
        {
            return "p3";
        }
        else if (percentageScore >= 70 && percentageScore < 80)
        {
            return "p4";
        }
        else if (percentageScore >= 80 && percentageScore < 90)
        {
            return "p5";
        }
        else if (percentageScore >= 90 && percentageScore < 100)
        {
            return "p6";
        }
        else if (percentageScore == 100)
        {
            return "p7";
        }
    }

    function handleShare(gameNumber, percentage, score, maxScore, hintsUsed, topWords)
    {
        var body = "Chiddle #" +  + gameNumber + "\n" 
                + percentage + "\n" 
                + score + "/" + maxScore
                + "\nTop Words: " + topWords
                + ((hintsUsed == 0) ? "\nNo Hints!" : "\nHints Used: " + hintsUsed);
    
        if (window.isMobile())
        {
            if (navigator.share) 
            {
                navigator.share(
                {
                    title: 'Chiddle #' + gameNumber,
                    text: body,
                });
            }
        }
        else 
        {
            navigator.clipboard
                .writeText(body)
                .then(() => 
                {
                    showAlert("Copied result to clipboard", 3000);
                })
                .catch(() => 
                {
                    showAlert("Could not copy result to clipboard", 3000);
                });
        }
    }

    const alertContainer = document.querySelector("[data-alert-container]")

    function showAlert(message, duration = 1000) 
    {
        const alert = document.createElement("div");
        alert.textContent = message;
        alert.classList.add("alert");
        alertContainer.prepend(alert);

        if (duration == null) 
        {
            return;
        }

        setTimeout(() => {
            alert.classList.add("hide");

            alert.addEventListener("transitionend", () => 
            {
                alert.remove()
            });            
        }, duration)
    }

    function openDialog(dialogId)
    {
        var dialog = document.getElementById(dialogId);

        dialog.showModal();
    }

    function closeDialog(element)
    {
        var dialog = element.closest('dialog');

        dialog.close();
    }

    return {
        getWordPoints: getWordPoints,
        getLetterPoints: getLetterPoints,
        getPercentageScoreClass: getPercentageScoreClass,
        getTopWords: getTopWords,
        getWordFromId: getWordFromId,
        handleShare: handleShare,
        showAlert: showAlert,
        openDialog: openDialog,
        closeDialog: closeDialog
    };
}();

export { lib }